import { api } from "utils/apiClient";
import { UserType } from "utils/constants";

export class NotificationUserService {
  constructor(loginData) {
    this._loginData = loginData;
    this._isSPUser = this._loginData.type == UserType.NTTsp;
  }

  // Adds or removes the caller in readBy; the server does it atomically and
  // leaves updatedAt alone. Other callers read only their own audience, so
  // only the NTT admin names it.
  async updateNotificationStatus(notification, userId, action) {
    try {
      await api(
        action === "read" ? "PUT" : "DELETE",
        `/notifications/${encodeURIComponent(notification.id)}/read`,
        { query: { type: this._isSPUser ? notification.target : undefined } }
      );
    } catch (error) {
      console.error(`Error ${action}ing notification:`, error);
      throw error;
    }
  }
}
